import router from "./router";
import store from './store'

router.beforeEach((to, from, next) => {
    document.title = to.meta.title || '辰有科技虚拟仿真实训平台'
    if (store.state.UserMeterList === null || store.state.UserMeterList.length == 0) {
        store.dispatch("getUserMeterList")
    }
    next();
});